import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'App/index';
import './i18n';
import { Provider } from 'react-redux';

import AppToast from 'components/App/Toast';

import store from './store';

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
      <AppToast />
    </BrowserRouter>
  </Provider>
);

const root = createRoot(document.getElementById('root'));
root.render(app);
